import { getApiUrl } from './api-url';

// Image URL for an item or ability, served by our backend which generates it once
// (via the free Pollinations API) and caches it on disk + in the DB by name — so the
// same sword/spell is never regenerated and the browser always loads a reliable URL.
function assetImageUrl(
  kind: 'item' | 'ability',
  name: string,
  description?: string,
  universe?: string
): string {
  const api = getApiUrl();
  const q = new URLSearchParams({ kind, name: (name || '').slice(0, 200) });
  if (description) q.set('description', description.slice(0, 300));
  if (universe) q.set('universe', universe);
  return `${api}/api/assets/image?${q.toString()}`;
}

export function itemImageUrl(name: string, description?: string, universe?: string): string {
  return assetImageUrl('item', name, description, universe);
}

export function abilityImageUrl(name: string, description?: string, universe?: string): string {
  return assetImageUrl('ability', name, description, universe);
}
